export default "__VITE_ASSET__IF2NBhs$__"